import React from 'react';
import JobApllyButton from './JobApllyButton';
class JobSingleHero extends React.Component {
  render() {
    function decodeHTMLEntities(text) {
      if(text){
        var entities = [
          ['amp', '&'],
          ['apos', '\''],
          ['#x27', '\''],
          ['#x2F', '/'],
          ['#39', '\''],
          ['#47', '/'],
          ['lt', '<'],
          ['gt', '>'],
          ['nbsp', ' '],
          ['quot', '"']
      ];

      for (var i = 0, max = entities.length; i < max; ++i)
          text = text.replace(new RegExp('&'+entities[i][0]+';', 'g'), entities[i][1]);
      }
      return text;
  }

  function checkForTranslation (label, filterType) {
    const cg_jobs_translated_filters = `${window.cg_jobs_translated_filters_v1}` ? JSON.parse(`${window.cg_jobs_translated_filters_v1}`) : {};

    // Split the label into an array if it contains commas
    const labels = label?.split(',');

    // Translate each value and join them back into a comma-separated string
    const translatedLabels = labels?.map((singleLabel) => {
      const trimmedLabel = singleLabel?.trim(); // Remove extra spaces
      if (
        cg_jobs_translated_filters &&
        filterType in cg_jobs_translated_filters &&
        encodeURIComponent(trimmedLabel) in cg_jobs_translated_filters[filterType] &&
        cg_jobs_translated_filters[filterType][encodeURIComponent(trimmedLabel)] !== ''
      ) {
        return cg_jobs_translated_filters[filterType][encodeURIComponent(trimmedLabel)];
      }
      return trimmedLabel; // Return original label if no translation is found
    });

    return translatedLabels?.join(', '); // Join the translated labels back into a string
  }

    return (
      <header className="header header--sub2 header--jobpost">
        <div className="box">
          <span className="box-tag">{decodeHTMLEntities(checkForTranslation(this.props.job_data.location, 'location'))}</span>
          <h1 className="box-title">{decodeHTMLEntities(this.props.job_data.title)}</h1>
          <JobApllyButton key={this.props.job_data._id} job_data={this.props.job_data} />
        </div>
        <div className="header-shape"></div>
      </header>
    )
  }
}

export default JobSingleHero;
